<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title> <ng-content select="[title]"></ng-content></mat-panel-title>
    </mat-expansion-panel-header>
    <hr />
    <ng-content select="[content]"></ng-content>
  </mat-expansion-panel>
</mat-accordion>
